<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <div id="generarInformes">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label class="generalLabel" for="informType">Tipo de informe</label>
            <VueNextSelect class="form-control generalInput" id="informType" :options="informTypeData"
              v-model.trim.lazy="v$.informType.$model" placeholder="" searchable="true" clear-on-close="true" close-on-select>
            </VueNextSelect>
            <div v-if="v$.informType.$dirty">
                <small class="form-text text-danger" v-if="v$.informType.required.$invalid">Campo requerido</small>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form autocomplete="off">
            <div class="d-flex justify-content-start mb-4">
              <a @click="all($event)" id='true' href="#">Seleccionar todo</a>&nbsp;
              <a @click="all($event)" id='false' href="#" class="ml-2">Limpiar selección</a>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="dniInform"
                    v-model.trim.lazy="fieldsToExtract.customer.legalIdentifier">
                  <label class="custom-control-label" for="dniInform">DNI</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="nombreInform"
                    v-model.trim.lazy="fieldsToExtract.customer.name">
                  <label class="custom-control-label" for="nombreInform">Nombre</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="apellidosInform"
                    v-model.trim.lazy="fieldsToExtract.customer.lastNames">
                  <label class="custom-control-label" for="apellidosInform">Apellidos</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="emailInform"
                    v-model.trim.lazy="fieldsToExtract.customer.email">
                  <label class="custom-control-label" for="emailInform">Email</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="numcontratoInform"
                    v-model.trim.lazy="fieldsToExtract.contractId">
                  <label class="custom-control-label" for="numcontratoInform">Número de contrato</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="phone1Inform"
                    v-model.trim.lazy="fieldsToExtract.customer.phone1">
                  <label class="custom-control-label" for="phone1Inform">Móvil</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="createdDateInform"
                    v-model.trim.lazy="fieldsToExtract.transDate">
                  <label class="custom-control-label" for="createdDateInform">Inicio contratación</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="contractStatusInform"
                    v-model.trim.lazy="fieldsToExtract.status">
                  <label class="custom-control-label" for="contractStatusInform">Estado contrato</label>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="storeNumberInform"
                    v-model.trim.lazy="fieldsToExtract.branch.storeNumber">
                  <label class="custom-control-label" for="storeNumberInform">Tienda</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="imeiInform"
                    v-model.trim.lazy="fieldsToExtract.customer.line.product.imei">
                  <label class="custom-control-label" for="imeiInform">IMEI</label>
                </div>
              </div>
              <div class="col-12 col-lg-3" v-if="statusSelected === 'UNPAID' && ($store.state.roles.Backoffice_member || $store.state.roles.Backoffice_supervisor)">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="isReportRecoveryInform"
                    v-model.trim.lazy="isReportRecovery">
                  <label class="custom-control-label" for="isReportRecoveryInform">Recobro</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row" @click="openAdditionalDataFunc()">
                  <div class="col-12">
                    <h6 class="float-left mr-3 mb-4">Campos adicionales</h6>
                    <v-icon v-if="!openAdditionalData" name="fa-chevron-down" scale="0.7" />
                    <v-icon v-if="openAdditionalData" name="fa-chevron-up" scale="0.7" />
                  </div>
                </div>
                <div v-if="openAdditionalData">
                  <div class="row mb-3">
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="tenantInform"
                          v-model.trim.lazy="fieldsToExtract.tenant">
                        <label class="custom-control-label" for="tenantInform">Distribuidor</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="merchantOrderIdInform"
                          v-model.trim.lazy="fieldsToExtract.merchantOrderId">
                        <label class="custom-control-label" for="merchantOrderIdInform">Id Orden del distribuidor</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="partCodeInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.product.partCode">
                        <label class="custom-control-label" for="partCodeInform">Id producto</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="monthInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.penalty.renewalFees.month">
                        <label class="custom-control-label" for="monthInform">Mes de factura</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="retailPriceInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.product.retailPrice">
                        <label class="custom-control-label" for="retailPriceInform">Precio</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="productNameInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.product.name">
                        <label class="custom-control-label" for="productNameInform">Nombre producto</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="repairExcessInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.policy.repairExcess">
                        <label class="custom-control-label" for="repairExcessInform">Coste franquicia reparación</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="policyNumberInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.policy.policyNumber">
                        <label class="custom-control-label" for="policyNumberInform">Nº póliza</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="replacementExcessInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.policy.replacementExcess">
                        <label class="custom-control-label" for="replacementExcessInform">Coste franquicia sustitución</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="rentServInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.rentServ">
                        <label class="custom-control-label" for="rentServInform">Servicio y suplido</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="taxBaseInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.taxBase">
                        <label class="custom-control-label" for="taxBaseInform">Base imponible</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="vatTypeInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.vatType">
                        <label class="custom-control-label" for="vatTypeInform">Tipo de impuesto</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="vatInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.vat">
                        <label class="custom-control-label" for="vatInform">Importe impuesto</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="monthlyNetFeeInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.monthlyNetFee">
                        <label class="custom-control-label" for="monthlyNetFeeInform">Cuota neta mensual</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="totalFeeInform"
                          v-model.trim.lazy="fieldsToExtract.customer.line.payment.totalFee">
                        <label class="custom-control-label" for="totalFeeInform">Cuota mensual</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 pt-3 pl-0">
              <div class="col-12">
                <button class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
                <button class="btn btn-primary generalPrimaryButton float-right" @click="submit()"
                  data-dismiss="modal" v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid">Exportar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';
import VueNextSelect from "vue-next-select";
import apiCSV from "../../../../../repositories/apiCSV";
import useVuelidate from "@vuelidate/core";
import { required } from '@vuelidate/validators'

export default {
  name: "ExportData",
  setup() {
    return { v$: useVuelidate() };
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'filters',
    'order',
    'statusSelected',
  ],
  data() {
    return {
      informTypeData: ["Bank reader", "Promociones", "Recobros"],
      informType: '',
      classes: this.class,
      shop: true,
      openAdditionalData: false,
      salesRep: false,
      partCode: false,
      paymentDate: false,
      urlDescarga: '#',
      isReportRecovery: false,
      fieldsToExtract: {
        contractId: true,
        status: true,
        tenant: false,
        tracking: false,
        transDate: true,
        receipts: false,
        nextReceiptDate: false,
        merchantOrderId: false,
        latestPayedReceipt: false,
        branch: {
          channel: false,
          salesRep: false,
          storeNumber: true
        },
        customer: {
          email: true,
          lastNames: true,
          legalIdentifier: true,
          line: {
            deliveryAddress: {
              city: false,
              postalCode: false,
              province: false,
              street: false,
            },
            product: {
              retailPrice: false,
              partCode: false,
              name: false,
              imei: true,
            },
            policy: {
              expenses: false,
              ips: false,
              monthlyGrossPolicy: false,
              monthlyNetPolicy: false,
              policyNumber: false,
              repairExcess: false,
              replacementExcess: false,
            },
            penalty: {
              cancelPenalty: false,
              renewalFees: {
                month: false,
                value: false,
              }
            },
            payment: {
              monthlyNetFee: false,
              rentServ: false,
              taxBase: false,
              totalFee: false,
              vat: false,
              vatType: false,
            }
          },
          pickup: false,
          phone1: true,
          name: true,
          address: {
            city: false,
            postalCode: false,
            province: false,
            street: false
          }
        }
      }
    };
  },
  validations() {
    return {
      informType: {
        required
      }
    };
  },
  components: {
    Modal,
    VueNextSelect
  },
  methods: {
    openAdditionalDataFunc() {
      this.openAdditionalData = !this.openAdditionalData;
    },
    submit() {
      localStorage.setItem('downloadCSV', true);
      if (this.statusSelected !== 'UNPAID' || this.statusSelected === "" ) {
        this.isReportRecovery = false;
      }
      apiCSV.getUrl(this.filters, this.fieldsToExtract, this.isReportRecovery).then((res) => {
        window.location.href = res.data.data.contractExport[0].downloadLink
        localStorage.setItem('downloadCSV', false);
      }).catch((error) => {
        if (error) {
          localStorage.setItem('downloadCSV', false);
          localStorage.setItem('errorDownloadCSV', true);
        }
      });
    },
    all: function (event) {
      let value
      if (event.target.id == 'true') {
        value = true
      }
      else {
        value = false
      }

      this.isReportRecovery = value;

      this.fieldsToExtract = {
        contractId: value,
        status: value,
        tenant: value,
        tracking: value,
        transDate: value,
        receipts: value,
        nextReceiptDate: value,
        merchantOrderId: value,
        latestPayedReceipt: value,
        branch: {
          channel: value,
          salesRep: value,
          storeNumber: value
        },
        customer: {
          email: value,
          lastNames: value,
          legalIdentifier: value,
          line: {
            deliveryAddress: {
              city: value,
              postalCode: value,
              province: value,
              street: value,
            },
            product: {
              retailPrice: value,
              partCode: value,
              name: value,
              imei: value,
            },
            policy: {
              expenses: value,
              ips: value,
              monthlyGrossPolicy: value,
              monthlyNetPolicy: value,
              policyNumber: value,
              repairExcess: value,
              replacementExcess: value,
            },
            penalty: {
              cancelPenalty: value,
              renewalFees: {
                month: value,
                value: value,
              }
            },
            payment: {
              monthlyNetFee: value,
              rentServ: value,
              taxBase: value,
              totalFee: value,
              vat: value,
              vatType: value,
            }
          },
          pickup: value,
          phone1: value,
          name: value,
          address: {
            city: value,
            postalCode: value,
            province: value,
            street: value
          }
        }
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#generarInformes {
  min-height: 300px;
}
.vue-select.direction-bottom.form-control.generalInput {
  // z-index: 20;
}
</style>
